import { useCookies } from 'react-cookie'
import { useStore } from '../providers/store'
import { formatStoreCookieName, getNextTenDaysDate, reduceCookiesByStore } from '../utils'
import { useCookiesByStoreActions } from './useCookiesByStoreActions'
import { useCallback, useMemo } from 'react'

export const useCookiesByStore = (deps = []) => {
	const { code: storeCode } = useStore()
	const storeDeps = deps.map((dep) => formatStoreCookieName(storeCode, dep))

	const [cookies, originalSetCookie, removeCookie] = useCookies(storeDeps)

	const cookiesByStore = useMemo(() => reduceCookiesByStore(cookies, storeCode), [cookies, storeCode])

	const setCookie = useCallback(
		(name, value, options = {}) =>
			originalSetCookie(name, value, {
				path: '/',
				expires: getNextTenDaysDate(),
				secure: true,
				...options,
			}),
		[originalSetCookie]
	)

	const { setCookiesByStore, removeCookiesByStore } = useCookiesByStoreActions({
		setCookie,
		removeCookie,
	})

	return [cookiesByStore, setCookiesByStore, removeCookiesByStore]
}
